import { EsignatureType } from '~/enums/EsignatureType';
import { ServiceRequestConfig } from '~/services/createService';
import { everest } from '~/services/serviceInstances';

export type CreateMultiTicketBundleRequest = {
  ticket_ids: string[];
  vendor: EsignatureType;
  return_url: string;
};

export type CreateMultiTicketBundleResponse = {
  id: string;
  links: {
    sender_view: string;
  };
  type: string;
};

export const createMultiTicketBundle = (
  request: CreateMultiTicketBundleRequest,
  options: ServiceRequestConfig = {},
): Promise<CreateMultiTicketBundleResponse> =>
  everest.post(
    '/packages/multi-ticket/',
    {
      ticket_ids: request.ticket_ids,
      vendor: request.vendor.toUpperCase(),
      return_url: request.return_url,
    },
    { showErrorToast: true, ...options },
  );
